import styled from '@emotion/styled/macro';

export const HeaderCurrency = styled.span`
    display: inline-block;
    width: 100%;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CellCurrency = styled.span`
    flex-grow: 1;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
